module.exports = __webpack_public_path__ + "img/p4.76ec92e7.png";